export const ROLE_RANK: Record<string, number> = {
  admin: 4,
  attorney: 3,
  paralegal: 2,
  intake_supervisor: 2,
  staff: 1,
  intake: 1,
};

export function getRoleRank(role: string | null | undefined, fallback = 1): number {
  return ROLE_RANK[role ?? ''] ?? fallback;
}
